import type { Translations } from './en';

export const hi: Translations = {
  'nav.inPlay': 'इन-प्ले',
  'nav.aviator': 'Aviator',

  // Bottom navigation bar
  'bottomNav.home': 'होम',
  'bottomNav.inPlay': 'इन-प्ले',
  'bottomNav.offers': 'ऑफ़र',
  'bottomNav.myMarkets': 'मेरे मार्केट',
  'bottomNav.referral': 'रेफ़रल',
  'bottomNav.passbook': 'पासबुक',
  'bottomNav.profile': 'प्रोफ़ाइल',

  'common.deposit': 'जमा करें',
  'common.withdraw': 'निकासी',
  'common.rules': 'नियम',
  'common.all': 'सभी',
  'common.viewAll': 'सभी देखें',
  'common.loading': 'लोड हो रहा है...',
  'auth.login': 'लॉगिन',
  'auth.signup': 'साइन अप',

  'language.select': 'भाषा चुनें',

  'search.placeholder': 'मैच / कैसीनो गेम खोजें',

  'search.short': 'खोजें',
  'search.matches': 'मैच',
  'search.casinoGames': 'कैसीनो गेम्स',
  'search.searching': 'खोज रहे हैं…',
  'search.noResults': '“{term}” के लिए कोई परिणाम नहीं',
  'search.hint': 'कोई टीम, लीग या गेम का नाम आज़माएँ।',

  'menu.accountStatement': 'खाता विवरण',
  'menu.betHistory': 'बेट इतिहास',
  'menu.activityLogs': 'गतिविधि लॉग',
  'menu.casinoBetHistory': 'कैसीनो बेट इतिहास',
  'menu.bonusStatement': 'बोनस विवरण',
  'menu.referral': 'रेफ़रल',
  'menu.setButtonValues': 'बटन मान सेट करें',
  'menu.changePassword': 'पासवर्ड बदलें',
  'menu.balance': 'बैलेंस',
  'menu.exposure': 'एक्सपोज़र',
  'menu.signOut': 'साइन आउट',

  'sidebar.sports': 'खेल',
  'sidebar.casino': 'कैसीनो',
  'sidebar.soon': 'जल्द',
  'sidebar.noCompetitions': 'कोई प्रतियोगिता नहीं',
  'sidebar.noMatches': 'कोई मैच नहीं',

  'home.casinoProviders': 'कैसीनो प्रदाता',
  'home.live': 'लाइव',
  'home.virtual': 'वर्चुअल',
  'home.noLiveMatches': 'अभी कोई लाइव मैच नहीं',
  'home.noMatches': 'कोई मैच उपलब्ध नहीं',

  'sport.Cricket': 'क्रिकेट',
  'sport.Football': 'फुटबॉल',
  'sport.Tennis': 'टेनिस',
  'sport.Kabaddi': 'कबड्डी',
  'sport.Politics': 'राजनीति',
  'sport.Basketball': 'बास्केटबॉल',
  'sport.Baseball': 'बेसबॉल',
  'sport.Table Tennis': 'टेबल टेनिस',
  'sport.Volleyball': 'वॉलीबॉल',
  'sport.Ice Hockey': 'आइस हॉकी',
  'sport.Rugby': 'रग्बी',
  'sport.Mixed Martial Arts': 'मिक्स्ड मार्शल आर्ट्स',
  'sport.Darts': 'डार्ट्स',
  'sport.Futsal': 'फुटसल',
  'sport.Horse Racing': 'घुड़दौड़',
  'sport.Greyhound Racing': 'ग्रेहाउंड रेसिंग',

  'market.limits': 'न्यूनतम: {min} | अधिकतम: {max}',
  'market.cashout': 'कैशआउट',

  'menu.profile': 'प्रोफ़ाइल',
  'menu.transactionReport': 'लेनदेन रिपोर्ट',
  'profile.activeBets': 'सक्रिय बेट्स',
  'profile.joinUs': 'हमसे जुड़ें',
  'profile.logout': 'लॉग आउट',
  'profile.balance': 'बैलेंस',

  'profile.description': 'आपका बैलेंस, वॉलेट, सेव किए गए खाते और रिपोर्ट एक ही जगह।',
  'profile.exposure': 'एक्सपोज़र',
  'profile.bonus': 'बोनस',

  // Deposit popup
  'deposit.availableBalance': 'उपलब्ध बैलेंस',
  'deposit.coins': 'कॉइन जमा करें',
  'deposit.enterCoins': 'कॉइन दर्ज करें',
  'deposit.makePayment': 'भुगतान करें',
  'deposit.loadingMethods': 'भुगतान विकल्प लोड हो रहे हैं...',
  'deposit.methodsError': 'भुगतान विकल्प लोड नहीं हो सके। कृपया फिर से प्रयास करें।',
  'deposit.noMethods': 'अभी कोई भुगतान विकल्प उपलब्ध नहीं है।',
  'deposit.uploadScreenshot': 'भुगतान स्क्रीनशॉट अपलोड करने के लिए यहाँ क्लिक करें',
  'deposit.optional': '(वैकल्पिक)',
  'deposit.utrLabel': 'यूनिक ट्रांज़ैक्शन रेफ़रेंस (UTR)',
  'deposit.utrPlaceholder': '6 से 23 अंकों का UTR/RRN नंबर',
  'deposit.txHash': 'ट्रांज़ैक्शन हैश',
  'deposit.paste': 'पेस्ट',
  'deposit.copy': 'कॉपी',
  'deposit.submit': 'सबमिट करें',
  'deposit.submitting': 'सबमिट हो रहा है...',
  'deposit.scanning': 'स्क्रीनशॉट से UTR पढ़ा जा रहा है...',
  'deposit.scanFound': 'आपके स्क्रीनशॉट से UTR भरा गया है, कृपया जाँच लें कि यह सही है।',
  'deposit.scanNotFound': 'स्क्रीनशॉट से UTR नहीं पढ़ा जा सका, कृपया इसे दर्ज करें।',
  'deposit.upiId': 'UPI आईडी',
  'deposit.name': 'नाम',
  'deposit.walletAddress': 'वॉलेट पता',
  'deposit.send': 'भेजें',
  'deposit.rateUnavailable': 'रूपांतरण दर उपलब्ध नहीं है, कृपया बाद में पुनः प्रयास करें।',
  'deposit.range': '{min} से {max} कॉइन के बीच जमा करें',
  'deposit.rangeFrom': 'न्यूनतम जमा {min} कॉइन',
  'deposit.noMethodForAmount': 'इस राशि के लिए कोई भुगतान तरीका उपलब्ध नहीं है। कृपया राशि बदलें।',
  'deposit.displayName': 'प्रदर्शित नाम',
  'deposit.upiDetails': 'UPI विवरण',
  'deposit.bankDetails': 'बैंक विवरण',
  'deposit.cryptoDetails': 'क्रिप्टो विवरण',
  'deposit.bankName': 'बैंक का नाम',
  'deposit.accountHolderName': 'खाताधारक का नाम',
  'deposit.accountNumber': 'खाता संख्या',
  'deposit.ifsc': 'IFSC कोड',
  'deposit.amount': 'राशि',
  'deposit.hashCode': 'हैश कोड',
  'deposit.enterHash': 'हैश कोड दर्ज करें',

  // Withdraw popup
  'withdraw.coins': 'कॉइन निकालें',
  'withdraw.minimum': 'न्यूनतम निकासी राशि {min} कॉइन',
  'withdraw.overBalance': 'राशि आपके उपलब्ध बैलेंस से अधिक है',
  'withdraw.continue': 'आगे बढ़ें',
  'withdraw.loadingAccounts': 'आपके खाते लोड हो रहे हैं...',
  'withdraw.accountsError': 'आपके खाते लोड नहीं हो सके। कृपया फिर से प्रयास करें।',
  'withdraw.noAccounts':
    'अभी कोई सहेजा गया खाता नहीं है। निकासी के लिए बैंक, UPI या क्रिप्टो खाता जोड़ें।',
  'withdraw.addAccount': 'खाता जोड़ें',
  'withdraw.bankAccount': 'बैंक खाता',
  'withdraw.cryptoWallet': 'क्रिप्टो वॉलेट',
  'withdraw.accountHolder': 'खाताधारक',
  'withdraw.accountNumber': 'खाता संख्या',
  'withdraw.ifsc': 'IFSC',
  'withdraw.amount': 'राशि',
  'withdraw.youReceive': 'आपको मिलेगा',
  'withdraw.submit': 'निकालें {amount}',
  'withdraw.processing': 'प्रोसेस हो रहा है...',
};
